module.exports = __webpack_public_path__ + "img/Cc.b5cd18c4.png";